import { lazy } from "react";
import { MODULE_IDS } from "../../../constants/enums";
import Loadable from "../../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../../router/AuthorizedRoute";
import { app_navbar_routes } from "../../../constants/app-navbar-routes";

const CategoryHeadTable = Loadable(
  lazy(() =>
    import("./CategoryHeadTable").then(({ CategoryHeadTable }) => ({
      default: CategoryHeadTable,
    })),
  ),
);

const ManageCategoryHeadForm = Loadable(
  lazy(() =>
    import("./ManageCategoryHeadForm").then(({ ManageCategoryHeadForm }) => ({
      default: ManageCategoryHeadForm,
    })),
  ),
);

export const categoryHeadRoutes = [
  {
    path: app_navbar_routes.app.expense.category_head,
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[MODULE_IDS.EXPENSE_CATEGORY_HEAD]}>
        <CategoryHeadTable />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${app_navbar_routes.app.expense.category_head}/manage`,
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[MODULE_IDS.EXPENSE_CATEGORY_HEAD]}>
        <ManageCategoryHeadForm />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${app_navbar_routes.app.expense.category_head}/manage/:uuid`,
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[MODULE_IDS.EXPENSE_CATEGORY_HEAD]}>
        <ManageCategoryHeadForm />
      </AuthorizedRoute>
    ),
  },
];
